import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient, HttpParams } from '@angular/common/http';
import { EqActionsVwMdl } from '../../../entities/actions/model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { catchError } from 'rxjs/operators';
@Injectable()
export class EquipmentActionsService {
  constructor(private _http: HttpClient) {

    }
    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
    public getEquipmentActions(Id : number, PageNo: number, PageSize: number): Observable<EqActionsVwMdl[]> {
      let options = {
        params: new HttpParams().set('Id', Id.toString()).set('PageNo', PageNo.toString()).set('PageSize', PageSize.toString())
      };
      return this._http.get<EqActionsVwMdl[]>("Api/EquipmentAction/getEquipmentActions", options).pipe(catchError(this.handleError));
    }
}
